import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const InputContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  color: #b8b8d1;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const InputField = styled(motion.input)`
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #2d2d44;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Vazirmatn', sans-serif;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #00d4ff;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
  }
  
  &::placeholder {
    color: #6c6c8a;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const TextArea = styled(motion.textarea)`
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #2d2d44;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Vazirmatn', sans-serif;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 100px;
  
  &:focus {
    outline: none;
    border-color: #00d4ff;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
  }
  
  &::placeholder {
    color: #6c6c8a;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Select = styled(motion.select)`
  width: 100%;
  padding: 12px 16px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #2d2d44;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-family: 'Vazirmatn', sans-serif;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #00d4ff;
    box-shadow: 0 0 0 3px rgba(0, 212, 255, 0.1);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  option {
    background: #1a1a2e;
    color: #ffffff;
  }
`;

const ErrorMessage = styled.div`
  color: #ff4757;
  font-size: 12px;
  margin-top: 5px;
`;

const Input = ({ 
  label, 
  error, 
  type = 'text', 
  as = 'input',
  ...props 
}) => {
  const InputComponent = {
    input: InputField,
    textarea: TextArea,
    select: Select,
  }[as];

  return (
    <InputContainer>
      {label && <Label>{label}</Label>}
      <InputComponent
        type={type}
        as={as}
        whileFocus={{ scale: 1.02 }}
        {...props}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputContainer>
  );
};

export default Input;
